/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react';
import { swalMessages } from 'src/constants';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import MaterialTable from 'material-table'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput';
import { makeStyles } from '@material-ui/core/styles';
import reportRequestService from 'src/services/reportRequestService';
import { permitsList } from 'src/constants/permits';
import { Context } from 'src/context/Contex';
import swal from 'sweetalert';
import * as moment from 'moment';
import styles from '../../../pages/AdminControl/styles';

const AdminRequestReportContainer = () => {
  const useStyles = makeStyles(styles);
  const [requestReports, setRequestReports] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [idAcept, setIdAcept] = useState('');
  const [create, setCreate] = useState({});
  const handleClose = () => setOpenModal(false);

  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.ADMIN_SOLICITUD_REPORTE_DATASTUDIO];

  // obtener solicitudes de crear reporte
  const getReportDataStudio = async () => {
    const { data, success } = await reportRequestService.getRequestReport();
    if (success) {
      setRequestReports(data);
    } else {
      swal(swalMessages.WARNING_DATASTUDIO);
    }
  };

  // Rechazar solicitud de creación de reporte
  const rejectReport = async (params) => {
    const body = {
      id: params,
      tipo: 'rechazar',
      novedad: 'Novedad de rechazo',
    };
    const response = await reportRequestService.putRejectReportRequest(body);
    if (response.success === 0) {
      swal(swalMessages.WARNING_DATASTUDIO);
    } else {
      swal(swalMessages.SUCCESFUL_REJECT);
      getReportDataStudio();
    }
  };

  // Aceptar solicitud de creacion de reporte
  const aceptReport = async (event) => {
    event.preventDefault();
    const body = {
      ...create,
      id: idAcept,
      tipo: 'completar',
    };
    const response = await reportRequestService.putRejectReportRequest(body);
    setOpenModal(false);
    if (response.success === 0) {
      swal(swalMessages.WARNING_DATASTUDIO);
    } else {
      swal(swalMessages.SUCCESSFUL_APPROVAL);
      getReportDataStudio();
    }
  };

  useEffect(() => {
    getReportDataStudio();
  }, []);

  const rejectRequest = (event) => {
    swal('¿Esta seguro que desea rechazar la solicitud?', {
      icon: 'warning',
      buttons: true,
      dangerMode: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result) {
        rejectReport(event.id);
      }
    });
  };

  const aceptRequest = (event) => {
    setOpenModal(true);
    setIdAcept(event.id);
  };

  const onDeleteRequest = (rowData) => {
    const { id } = rowData;
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const { success } = await reportRequestService.deleteRequest(id);
        if (success) {
          const updatedRequest = requestReports.filter((rqst) => rqst.id !== id);
          setRequestReports(updatedRequest);
          swal(swalMessages.SUCCEFUL_DELETE);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  return (
    <>
      <main style={{ margin: '10px' }}>
        <CardTitle
          title="Administración solicitud de permisos"
          subTitle=" Aprobación o rechazo de solicitud de reportes"
        />

        <MaterialTable
          style={{ color: 'ff9800' }}
          title="Solicitudes"
          columns={[
            { title: 'Fecha', field: 'Fecha' },
            { title: 'Reporte', field: 'Reporte' },
            { title: 'Descripción', field: 'Descripcion' },
            { title: 'Estado', field: 'Estado' },
            { title: 'Fuentes', field: 'Fuentes' },
            { title: 'Tipo', field: 'Tipo' },
          ]}
          data={requestReports?.map((item) => ({
            id: item.id,
            Fecha: moment(item.creacion).format('DD/MM/YYYY'),
            Reporte: item.nombre,
            Descripcion: item.descripcion,
            Estado: item.estado,
            Tipo: item.tipo_reporte,
            Fuentes: item.fuentes?.map((fuente) => fuente.nombre).join(),
          }))}
          actions={
            permitValue >= 3
              ? [
                {
                  icon: 'check',
                  tooltip: 'Aprobar solicitud',
                  onClick: (event, rowData) => aceptRequest(rowData),
                  // alert('You saved ' + rowData.name),
                },
                (rowData) => ({
                  icon: 'clear',
                  tooltip: 'Rechazar solicitud',
                  onClick: (event, rowData) => rejectRequest(rowData),
                }),
                {
                  icon: 'delete',
                  tooltip: 'Eliminar solicitud',
                  onClick: (event, rowData) => onDeleteRequest(rowData),
                  hidden: permitValue < 4,
                },
              ]
              : false
          }
          options={{
            actionsColumnIndex: -1,
          }}
        />
        <div>
          <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <form onSubmit={aceptReport}>
              <DialogTitle id="alert-dialog-title" />
              <DialogContent style={{ width: '30rem' }}>
                <DialogContentText id="alert-dialog-description">
                  <h4>Formulario Aprobación</h4>
                </DialogContentText>
                <CustomInput
                  labelText="Url"
                  id="Url"
                  formControlProps={{
                    required: true,
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => setCreate({ ...create, url: event.target.value }),
                    type: 'url',
                    autoComplete: 'off',
                  }}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="warning">
                  Cancelar
                </Button>
                <Button type="onSubmit" color="warning" autoFocus>
                  Completar
                </Button>
              </DialogActions>
            </form>
          </Dialog>
        </div>
      </main>
    </>
  );
};

export default AdminRequestReportContainer;
